import { css } from 'styled-components';

export const articleSummary = css`
  height: 100%;
  a {
    display: block;
    height: 100%;
    overflow: hidden;
    border-bottom: 1em solid transparent;
  }
`;

export const textBlock = css`
  padding: 20px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 100%;
  overflow: hidden;
  > p {
    margin: 10px 0 0 0;
  }
  @media only screen and (max-width: 794px) {
    padding: 20px;
  }
  
  [class*='Headingstyle__Heading-sc'] {
    margin-top: 0 !important;
  }
`;

export const heading = css`
  margin: 0px;
  svg {
    stroke: red;
    margin-left: 5px;
    height: 0.6em;
    padding-top: 2px;
  }
`;

export const bgWhite = css`
  background: var(--white);
`;

export const bgAbbey = css`
  background: var(--gallery);
`;


